import { FC } from 'react';

import operationTypes from 'constants/operationTypes';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import OperationDetailsTable from './OperationDetailsTable';

const OperationDetailsDataTab: FC = () => {
  const { data, actions } = useOperationDetailsPage();

  const isIndependentOperation =
    data.operation?.operationType === operationTypes.DIVIDENDS_DISTRIBUTION ||
    data.operation?.operationType === operationTypes.CONTRIBUTION;

  return (
    <div>
      <OperationDetailsTable />

      {isIndependentOperation && (
        <DataTablePagination
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.totalPartners || 0}
          paginate={actions.handleChangePage}
          currentPage={data.currentPage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};

export default OperationDetailsDataTab;
